import React from 'react';

export const TransportTabSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 w-full mb-16">
      {/* Transport Details Card */}
      <div className="bg-white rounded-xl p-6 border border-[#E4E8EA] animate-pulse">
        {/* Section Title */}
        <div className="flex justify-between items-center mb-6">
          <div className="h-6 w-48 bg-gray-200 rounded"></div>
          <div className="h-10 w-32 bg-gray-200 rounded"></div>
        </div>

        {/* Details Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Card Content Section 1 */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gray-200"></div>
              <div className="space-y-2">
                <div className="h-5 w-40 bg-gray-200 rounded"></div>
                <div className="h-4 w-28 bg-gray-100 rounded"></div>
              </div>
            </div>

            <div className="pt-2 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-48 bg-gray-100 rounded"></div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-36 bg-gray-100 rounded"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Card Content Section 2 */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gray-200"></div>
              <div className="space-y-2">
                <div className="h-5 w-40 bg-gray-200 rounded"></div>
                <div className="h-4 w-28 bg-gray-100 rounded"></div>
              </div>
            </div>

            <div className="pt-2 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-48 bg-gray-100 rounded"></div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-36 bg-gray-100 rounded"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Card Content Section 3 */}
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-gray-200"></div>
              <div className="space-y-2">
                <div className="h-5 w-40 bg-gray-200 rounded"></div>
                <div className="h-4 w-28 bg-gray-100 rounded"></div>
              </div>
            </div>

            <div className="pt-2 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-48 bg-gray-100 rounded"></div>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full bg-gray-200 mt-1"></div>
                <div className="space-y-1">
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                  <div className="h-5 w-36 bg-gray-100 rounded"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Emergency Contacts Card */}
      <div className="bg-white rounded-xl p-6 border border-[#E4E8EA] animate-pulse">
        <div className="h-6 w-48 bg-gray-200 rounded mb-6"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {[...Array(2)].map((_, i) => (
            <div
              key={i}
              className="flex items-start gap-4 p-4 rounded-lg bg-[#F5F8F9]"
            >
              <div className="w-10 h-10 rounded-full bg-gray-200"></div>
              <div className="space-y-3 flex-1">
                <div className="h-5 w-40 bg-gray-200 rounded"></div>
                <div className="flex items-center gap-2">
                  <div className="h-5 w-5 rounded-full bg-gray-200"></div>
                  <div className="h-5 w-32 bg-gray-100 rounded"></div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="h-5 w-5 rounded-full bg-gray-200"></div>
                  <div className="h-5 w-48 bg-gray-100 rounded"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
